import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {getSortPropertyList, staticTagsInColumn, updateView} from "../../../model";
import {
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    imgPathPerfix,
    isDarkMode,
    isStringNullOrEmpty
} from "../../utils";
import {KEY_PROPERTY_LIST_STATUS} from "../../Const";
import { Input,Tooltip,Checkbox,Spin } from "antd";
import { t } from "i18next";

const PropertyContentInfo = forwardRef((props:{addNewPropertyToTableView:any,onClosePopover:any,selectView:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onRefreshPropertyList:onRefreshPropertyList
    }))
    const [arrayPropertys, setArrayPropertys] = useState([]);//属性列表
    const [propertyListStatus, setPropertyListStatus] = useState<any>({'default': true, 'custom': true})
    const [mapColumnInTags, setMapColumnInTags] = useState<any>({});
    const [searchProperty, setSearchProperty] = useState<any>('');
    // const [selectView, setSelectView] = useState<any>(null);
    const [searchKey, setSearchKey] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    const mSearchKey = useRef(null);

    useEffect(() => {
        refreshPropertyList();
    }, []);


    const onRefreshPropertyList = ()=>{

    }

    /**
     * 刷新属性列表
     */
    function refreshPropertyList() {
        getSortPropertyList().then(res => {
            setArrayPropertys(res);
        })
    }

    const isInUse = (property) => {
        return props.selectView?.columns?.some(p => p.id == property.id);
    }

    /**
     * 属性列表item
     * @param szType
     */
    const renderPropertyItem = (szType) => {
        const arrayPros = arrayPropertys.filter(p => p.groupName == szType);
        return arrayPros.map(p => {
            const isIn = isInUse(p);
            return <div
                className={`flex-row-vertical-center hovered-gray show-image-in-hover default-font-size ${isIn ? '' : 'cursor-pointer'}`}
                style={{
                    height: propertyListStatus[szType] ? '36px' : '0px',
                    minHeight: propertyListStatus[szType] ? '36px' : '0px',
                    opacity: '1',//isInUse(p) ? '0.5' : '1',
                    cursor: 'pointer',//isIn ? 'not-allowed' : 'pointer',
                    overflow: 'hidden',
                    padding: '0 12px'
                }} onMouseDown={() => {
                //添加属性
                props.onClosePopover();
                window.onAddPropertyInPopover(p);
            }} onMouseEnter={(e) => {
                //这里统计
                staticTagsInColumn(p.id).then(res => {
                    const mapNew = {...mapColumnInTags};
                    mapNew[p.id] = res;
                    setMapColumnInTags(mapNew);
                })
            }}>
                <img className={'img-16'} src={getImagePathWithThemeSvg(p.icon)}/>
                <span className={'ml-8 span-single-line'}>{szType == 'default' ? t(p.name) : p.name}</span>
                <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                    {
                        mapColumnInTags[p.id] &&
                        //统计这个列被哪些tag使用.
                        <Tooltip arrow={false} title={mapColumnInTags[p.id]}>
                            <img className={'img-16 show-image-in-hover'}
                                 src={getImagePathWithThemeSvg('property_in_used_tag')}/>
                        </Tooltip>
                    }
                    <Checkbox checked={isIn} style={{marginLeft: '12px'}}/>
                    {
                        // isIn &&
                        // <span className={'ml-6'}>{`(${t("In use")})`}</span>
                    }
                </div>

            </div>
        })
    }

    /**
     * 渲染搜索后缀
     */
    const renderSuffix = () => {
        if (isSearching) {
            return <>
                <Spin indicator={<img className={'img-16 rotating-image mr-6'}
                                      src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
            </>
        } else {
            return <img className='img-mini-small-8 cursor-pointer'
                        style={{display: isStringNullOrEmpty(searchKey) ? "none" : "inherit", marginRight: '6px'}}
                        onClick={() => {
                            // setSearchKey('');
                            // mSearchKey.current = '';
                            // setIsSearching(false);
                            // if (props.selectView.type == 'tableView' || props.selectView.value == 'tableView') {
                            //     tableViewRef.current?.doSearch('');
                            // } else {
                            //     mszSearchKey = mSearchKey.current;
                            //     refreshData();
                            // }
                        }}
                        src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>
        }
    }

    return <div className={'default-font-family'}>
        <span className={'dialog-title'} style={{margin: '0 12px'}}>{t('Add property')}</span>
        <div className={'line'} style={{margin: '12px 0px'}}></div>
        <Input className={'input-border'} style={{width: 'calc(100% - 24px)', margin: '0 12px'}}
               variant={"borderless"}
               value={searchProperty}
               suffix={renderSuffix()} placeholder={t('Search properties')} onMouseDown={(e)=>{
                   e.stopPropagation();
        }} onChange={(event) => {
            setSearchProperty(event.currentTarget.value);
            // setIsSearching(true);
            const szSearch = event.currentTarget.value.toLowerCase();
            if (!szSearch) {
                refreshPropertyList();
            } else {
                const arrayNewPropertys: any = [];
                for (let i = 0; i < arrayPropertys.length; i++) {
                    const item = arrayPropertys[i];
                    if (item.name.toLowerCase().includes(szSearch)) {
                        arrayNewPropertys.push(item);
                    }
                }
                setArrayPropertys(arrayNewPropertys);
            }
        }}/>

        <div className={'flex-col mt-6 default-font-size'} style={{
            maxHeight: `${document.body.offsetHeight * 0.5}px`,
            overflowY: 'auto',
            userSelect: 'none',
        }}>
            <div>
                <div className={'flex-row-vertical-center cursor-pointer'}
                     style={{height: '32px', userSelect: 'none', margin: '0 12px'}}
                     onMouseDown={(e) => {
                         const newPropertyStatus = {...propertyListStatus};
                         newPropertyStatus['default'] = !newPropertyStatus['default'];
                         setPropertyListStatus(newPropertyStatus);
                         localStorage.setItem(KEY_PROPERTY_LIST_STATUS, JSON.stringify(newPropertyStatus));
                     }}>
                    <img className={'img-16'}
                         src={getImagePathWithThemeSvg(propertyListStatus['default'] ? 'property_dropdown_expand' : 'property_dropdown_collapse')}/>
                    <span className={'ml-6 font-family-semi-bold'}>{t('System properties')}</span>
                </div>
                {
                    renderPropertyItem('default')
                }
            </div>
            {
                arrayPropertys.filter(p => p.groupName == 'custom').length > 0 &&
                <div>
                    <div className={'flex-row-vertical-center cursor-pointer'}
                         style={{height: '32px', userSelect: 'none', margin: '0 12px'}}
                         onMouseDown={(e) => {
                             const newPropertyStatus = {...propertyListStatus};
                             newPropertyStatus['custom'] = !newPropertyStatus['custom'];
                             setPropertyListStatus(newPropertyStatus);
                             localStorage.setItem(KEY_PROPERTY_LIST_STATUS, JSON.stringify(newPropertyStatus));
                         }}>
                        <img className={'img-16'}
                             src={getImagePathWithThemeSvg(propertyListStatus['custom'] ? 'property_dropdown_expand' : 'property_dropdown_collapse')}/>
                        <span className={'ml-6 font-family-semi-bold'}>{t('Custom properties')}</span>
                    </div>
                    {
                        renderPropertyItem('custom')
                    }
                </div>
            }
        </div>
        <div className={'line'} style={{margin: '6px 0px 12px 0px'}}></div>
        <div className={'flex-row-vertical-center cursor-pointer default-font-size'} onMouseDown={(e) => {
            props.onClosePopover();
            window.showDialogAddProperty(null, (newProperty) => {
                props.addNewPropertyToTableView(newProperty);
            });
        }} style={{margin: '0 12px'}}>
            <img className={'img-16'} src={getImagePathWithThemeSvg('add_blue')}/>
            <span className={'ml-8'} style={{color: 'var(--primary-color)'}}>{t('CreateNewProperty')}</span>
        </div>

        <div className={'flex-row-vertical-center cursor-pointer default-font-size mt-10'}
             style={{height: '26px', margin: '10px 12px 0px 12px'}} onMouseDown={() => {
            //转到property
            props.onClosePopover();
            window.navPage('property');
        }}>
            <img className={'img-16'} src={getImagePathWithThemeSvg('manage_properties')}/>
            <span className={'ml-8'}>{t('Manage properties')}</span>
        </div>
    </div>
})

export default PropertyContentInfo;